export default __webpack_public_path__ + "tmp_src/components/SideCart/SideCart~aurora.css.liquid";